module.exports = __webpack_public_path__ + "static/media/alarm.72374053.svg";